<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.logPlatform" clearable @change="partserch"
                        placeholder="请选择平台" style="width: 130px;">
                        <el-option label="pc" :value="1"></el-option>
                        <el-option label="wx" :value="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.logType" clearable @change="partserch"
                        placeholder="请选择类型" style="width: 130px; margin-left: 10px;">
                        <el-option label="其他" :value="0"></el-option>
                        <el-option label="查询" :value="1"></el-option>
                        <el-option label="新增" :value="2"></el-option>
                        <el-option label="编辑" :value="3"></el-option>
                        <el-option label="删除" :value="4"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.logUserName" clearable placeholder="请输入操作人"
                        style="width: 130px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.logApi" clearable placeholder="请输入接口名"
                        style="width: 150px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" icon="el-icon-refresh" @click="handleCopy"
                        style="margin-left: 10px">复制迁移</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import {
    getSysLogCopyListTwo, updateSysLogCopyDoTwo
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "logPlatform",
                    key: "logPlatform",
                    title: "平台",
                    align: "center",
                    width: 70,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.logPlatform == 1 ? 'pc' : 'wx';
                    },
                },
                {
                    field: "logType",
                    key: "logType",
                    title: "操作类型",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeMap = { 0: '其他', 1: '查询', 2: '新增', 3: '编辑', 4: '删除' };
                        return typeMap[row.logType] || '-';
                    },
                },
                {
                    field: "logApi",
                    key: "logApi",
                    title: "接口名",
                    align: "center",
                    width: 200,
                },
                {
                    field: "logPath",
                    key: "logPath",
                    title: "接口地址",
                    align: "center",
                    width: 250,
                },
                {
                    field: "logIp",
                    key: "logIp",
                    title: "ip地址",
                    align: "center",
                    width: 130,
                },
                {
                    field: "logUserPhone",
                    key: "logUserPhone",
                    title: "操作人员",
                    align: "center",
                    width: 100,
                },
                {
                    field: "logTime",
                    key: "logTime",
                    title: "操作时间",
                    align: "center",
                    width: 160,
                },
            ],
            tableData: [],
            formDatas: {
                logPlatform: '',
                logType: '',
                logUserName: '',
                logApi: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        handleCopy() {
            this.$prompt('请输入处理条数(万)', '复制迁移', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[1-9]\d*$/,
                inputErrorMessage: '请输入正整数'
            }).then(({ value }) => {
                this.openLoading();
                updateSysLogCopyDoTwo({ nums: value }).then((res) => {
                    this.loadings.close();
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '复制迁移成功'
                        });
                        this.getList();
                    }
                }).catch(() => {
                    this.loadings.close();
                });
            }).catch(() => {});
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getSysLogCopyListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getSysLogCopyListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getSysLogCopyListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
